export default {
  components: {},
  props: {},
  data () {
    return {
      demolitionInfo_show: true,
      form: {
        projectId: 0, //项目id
        areaId: 0, //区域ID
        code: "", //编号
        section: "", //标段信息
        community: "", //所属集体
        holder: "", //权益人
        feature: "", //特征
        amount: "", //金额(元)
        area: "", //面积(亩)
        type: "", //类型
        status: 0, // 征拆状态: 0:已完成；1:未完成
        completionDate: "", //日期
        remarks: "", //备注
        isOutOfBound: 0, // 是否越界: 0:未越界；1:已越界
        excessArea: "", //超征面积(亩)
      },
      options: {
        demolition_info_label: [
          { value: "code", label: "编号" },
          { value: "section", label: "标段" },
          { value: "holder", label: "权益人" },
          { value: "amount", label: "金额" },
          { value: "area", label: "面积" },
          { value: "status", label: "征地状态" },
        ],
      },
      // demolitionInfo_data: [
      //   //el-table的数据内容
      //   {
      //     pkey: "编号",
      //     pvalue: "DX01011",
      //   },
      //   {
      //     pkey: "标段",
      //     pvalue: "5",
      //   },
      //   {
      //     pkey: "权益人",
      //     pvalue: "某某某",
      //   },
      //   {
      //     pkey: "金额",
      //     pvalue: "0（元）",
      //   },
      //   {
      //     pkey: "面积",
      //     pvalue: "0.66（亩）",
      //   },
      //   {
      //     pkey: "征地状态",
      //     pvalue: "未完成",
      //   },
      // ],

      isFold: false,
    };
  },
  mounted () {
    // this.$refs["multipleTable"].$nextTick(function () {
    //            this.escrollY(
    //              ".el-table__body-wrapper",
    //              ".el-table__header-wrapper"
    //            );
    // 		   console.log('触发！');
    //          })
  },
  computed: {
    demolitionInfo_data: function () {
      let demolitionInfoArr = [],
        label;
      Object.keys(this.form).forEach((element) => {
        if (
          element == "code" ||
          element == "section" ||
          element == "holder" ||
          element == "area" ||
          element == "status" ||
          element == "amount"
        ) {
          label = this.options.demolition_info_label.find((e) => {
            return e.value == element;
          }).label;
          if (element != "status") {
            demolitionInfoArr.push({
              pkey: label,
              pvalue: this.form[element],
            });
          } else {
            demolitionInfoArr.push({
              pkey: label,
              pvalue: this.form[element] == 0 ? "已完成" : "未完成",
            });
          }
        }
      });
      return demolitionInfoArr;
    },
  },
  methods: {
    demolitionInfo_click () {
      //this.demolitionInfo_show=false;
      //alert("触发");
      this.$emit("demolitionInfo_close");
    },
    // 方便后面可以传地图数据给父组件。
    editDemolitionInfo () {
      this.$emit("demolitionInfo_edit");
    },
  },
  watch: {},
};
//console.log(localStorage.getItem(ColorPicker));
